import { useState, useEffect } from "react";

const API = "https://pax-ordinis-app-db9z.vercel.app/api";

const Rhythm = () => {

const [rule,setRule]=useState(null);
const [rhythm,setRhythm]=useState({});
const [saveStatus,setSaveStatus]=useState("");
const [loaded,setLoaded]=useState(false);


const anchorMoments=[

{ id:"morning",name:"Morning",description:"Rising and offering the day" },

{ id:"midday",name:"Midday",description:"Pausing to remember" },

{ id:"afternoon",name:"Afternoon",description:"Returning to presence" },

{ id:"evening",name:"Evening",description:"Gathering and releasing" },

{ id:"night",name:"Night",description:"Resting in trust" }

];


function formatSavedTime(){

const now=new Date();

return(
"Saved "+
now.toLocaleDateString("en-US",{month:"short",day:"numeric"})+
", "+
now.toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit"})
);

}


/* LOAD */

useEffect(()=>{

const token=localStorage.getItem("token");
if(!token) return;

fetch(API+"/daily-rule",{

headers:{
Authorization:"Bearer "+token
}

})
.then(res=>res.json())
.then(data=>{

setRule(data);

setRhythm(data.rhythm || {});

setLoaded(true);

});

},[]);



/* SAVE */

function saveRhythm(newState){

if(!loaded) return;

const token=localStorage.getItem("token");
if(!token) return;

setSaveStatus("Saving...");

const updatedRule={

...rule,

rhythm:newState

};

fetch(API+"/daily-rule",{

method:"POST",

headers:{
"Content-Type":"application/json",
Authorization:"Bearer "+token
},

body:JSON.stringify(updatedRule)

})
.then(()=>{

setRule(updatedRule);

setSaveStatus(formatSavedTime());

})
.catch(()=>{

setSaveStatus("Offline");

});

}



function handleClick(id){

const updated={

...rhythm,

[id]:!rhythm[id]

};

setRhythm(updated);

saveRhythm(updated);

}



return(

<div data-testid="space-rhythm" className="rhythm-space">

<p className="rhythm-subtitle">The Shape of the Day</p>

<h1 className="rhythm-title">Rhythm</h1>

<div data-testid="anchor-moments" className="anchor-moments">

{anchorMoments.map(moment=>(

<div

key={moment.id}

className={`anchor-moment ${rhythm[moment.id]?"moment-complete":""}`}

onClick={()=>handleClick(moment.id)}

>

<h2 className="moment-name">

{rhythm[moment.id]?"✓ ":"○ "}{moment.name}

</h2>

<p className="moment-description">

{moment.description}

</p>

</div>

))}

</div>


<div style={{

marginTop:"10px",
fontSize:"12px",
opacity:0.6

}}>

{saveStatus}

</div>


</div>

);

};

export default Rhythm;
